module.exports = __webpack_public_path__ + "img/metaLoginImg.e6cd7e10.svg";